import React, { useEffect, useRef } from "react";

export const MainPageInfoBox = ({ onClose }) => {
  const infoBoxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (infoBoxRef.current && !infoBoxRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="popup">
      <div className="popup-content" ref={infoBoxRef}>
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h3>About this website</h3>
        <p>
          Behavioral economic research has shown that on a population level,
          people exhibit various biases when making financial decisions. Most
          people are{" "}
          <a href="https://en.wikipedia.org/wiki/Risk_aversion">risk averse</a>,
          meaning that they prefer sure bets to risky outcomes. Most people are
          more{" "}
          <a href="https://en.wikipedia.org/wiki/Prospect_theory">
            risk seeking in losses
          </a>
          , meaning that they're more likely to prefer gambling when losing
          money than when winning money. Finally, most people have{" "}
          <a href="https://en.wikipedia.org/wiki/Marginal_utility">
            decreasing marginal utility
          </a>
          , meaning that the first hundred dollars they earn is more valuable to
          them than the next hundred dollars.
        </p>
        <p>
          But everyone is different - some people are more risk averse than
          others; some people act the same in losses and gains; and everyone has
          a different utility curve for income.
        </p>
        <p>
          Each person is unique. This website serves as a mechanism to collect
          data on risk tolerances and help people understand their biases and
          preferences.
        </p>
        <p>
          <b>Imagine the choices are real.</b> To get accurate results, you must
          do your best to simulate what you'd really do in reality if faced with
          this choice, so pretend that the money is really yours.
        </p>
        <p>That said, there are no wrong answers - just be true to yourself.</p>
        <h3>My stuff</h3>
        <p>
          You can check out more of my stuff at{" "}
          <a href="https://www.johngrandolph.com">johngrandolph.com</a>. You can
          join my mailing list <a href="http://eepurl.com/iT60j6">here</a>.
        </p>
      </div>
    </div>
  );
};
